<button
  #pop="bs-popover"
  type="button"
  class="info-tooltip-trigger"
  [attr.aria-label]="ariaLabel || ('public.global.moreInformation' | translate)"
  [attr.aria-expanded]="pop.isOpen"
  [attr.aria-describedby]="pop.isOpen ? popoverTextId : null"
  [popover]="popoverContent"
  placement="top"
  triggers="click"
  [outsideClick]="true"
  container="body"
  boundariesElement="viewport"
  containerClass="info-tooltip-popover"
  (onShown)="onShown()"
  (onHidden)="onHidden()"
  (keydown.escape)="pop.hide()"
>
  <span class="info-tooltip-icon" aria-hidden="true">
    <i class="fa fa-circle info-tooltip-icon-circle"></i>
    <i class="fa info-tooltip-icon-glyph" [ngClass]="icon"></i>
  </span>
</button>

<ng-template #popoverContent>
  <app-dialog
    [dialogTitle]="heading || ('public.global.moreInformation' | translate)"
    (closeClick)="pop.hide()"
  >
    <div class="info-tooltip-popover-text" [id]="popoverTextId">{{ text }}</div>
  </app-dialog>
</ng-template>
